import { VITRINS_WITH_MINDBOX_VISIT_EVENT } from '@src/constants/mindbox';

export const checkIsNeededToSendVisitMindboxEvent = (path: string) => VITRINS_WITH_MINDBOX_VISIT_EVENT.has(path);
